module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"section":{"title":"Feeds"}}}')
  delete Component.options._Ctor
}
